import React from 'react';
import Spinner from '../Spinner';
import { BORDER_RADIUS, mainColor } from '../../constants';

function Button(props) {
  const getPadding = padding => {
    switch (padding) {
      case 'none':
        return '0px';
      case 'xs':
        return '5px 10px';
      case 'sm':
        return '10px 18px';
      case 'lg':
        return '10px 40px';
      default:
        break;
    }
    return '';
  };


  const { color = 'primary', onClick, className = '', children, outlined = false, disabled, style = {}, isLoading } = props;
  let { minWidth = '100px', padding = 'sm' } = props;
  if (color === 'link') {
    padding = 'none';
    minWidth = '1px';
  }
  return (
    <>
      {isLoading && <Spinner size={20} />}
      {!isLoading && (
        <button
          type='button'
          onClick={onClick}
          className={`btn ${outlined ? `btn-outline-${color}` : `btn-${color}`} ${className}`}
          style={{
            minWidth,
            padding: getPadding(padding),
            ...style,
            borderColor:
              color === 'light'
                ? mainColor.colorGray
                : color === 'gray'
                  ? mainColor.colorDarkGray
                  : '',
            borderRadius: BORDER_RADIUS
          }}
          disabled={disabled}
        >
          {children}
        </button>
      )}
    </>
  );

}

export default Button;
